import { render, staticRenderFns } from "./loginSASP.vue?vue&type=template&id=e6134920&scoped=true"
import script from "./loginSASP.vue?vue&type=script&lang=js"
export * from "./loginSASP.vue?vue&type=script&lang=js"
import style0 from "./loginSASP.vue?vue&type=style&index=0&id=e6134920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6134920",
  null
  
)

export default component.exports